export const AGENCIAS_FRAME_PATH = "/agencias-frame";
